export default {
    data() {
        return {
            saving : false,
            dialog : false,
            mwSize : '640px'
        }
    },
    props    : {
        reloadGrid : Function
    },
    methods  : {
        toggleDialog() {
            this.dialog = !this.dialog;
        },
    },
    computed : {
        fullscreen() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        maxWidth() {
            return this.fullscreen ? undefined : this.mwSize;
        },
        transition() {
            return this.fullscreen ? 'dialog-bottom-transition' : undefined;
        },
        id() {
            return null;
        },
        isEditing() {
            return this.mode.action == 'Editar';
        },
        mode() {
            return (this.id) ? {
                action : 'Editar',
                method : 'patch',
                icon   : 'edit',
                color  : 'warning',
                snack  : 'Registro alterado com sucesso!'
            } : {
                action : 'Cadastrar',
                method : 'post',
                icon   : 'add',
                color  : 'primary',
                snack  : 'Registro cadastrado com sucesso!'
            };
        }
    }
}
